import CustomerFormModule from './Form'
import * as Styles from 'layouts/PrivateLayout.styles'

const CreateCustomerModule = () => {
  
  return (
    <>
      <Styles.CreateEditPageTitleContainer>
        Add new customer
      </Styles.CreateEditPageTitleContainer>
      <CustomerFormModule></CustomerFormModule>
    </>    
  )
}

export default CreateCustomerModule
